import { api, authHeaders } from '../api/api';

export interface GlossaryEntry {
  id: string;
  term: string;
  canonical: string;
  category: string;
  description?: string;
  is_active: boolean;
  created_at: string;
  created_by?: string;
  updated_at: string;
  updated_by?: string;
}

export interface CreateGlossaryPayload {
  term: string;
  canonical: string;
  category: string;
  description?: string;
  created_by?: string;
}

export interface UpdateGlossaryPayload {
  term?: string;
  canonical?: string;
  description?: string;
  updated_by?: string;
}

export const glossaryService = {
  getAllEntries: async (includeInactive = false): Promise<GlossaryEntry[]> => {
    const headers = await authHeaders();
    const response = await api.get<GlossaryEntry[]>(
      `/api/glossary?include_inactive=${includeInactive}`,
      { headers }
    );
    return response.data;
  },

  createEntry: async (payload: CreateGlossaryPayload): Promise<GlossaryEntry> => {
    const headers = await authHeaders();
    const response = await api.post<GlossaryEntry>('/api/glossary', payload, { headers });
    return response.data;
  },

  updateEntry: async (entryId: string, category: string, payload: UpdateGlossaryPayload): Promise<GlossaryEntry> => {
    const headers = await authHeaders();
    const response = await api.put<GlossaryEntry>(
      `/api/glossary/${entryId}?category=${category}`,
      payload,
      { headers }
    );
    return response.data;
  },

  deleteEntry: async (entryId: string, category: string): Promise<{ message: string }> => {
    const headers = await authHeaders();
    const response = await api.delete<{ message: string }>(
      `/api/glossary/${entryId}?category=${category}`,
      { headers }
    );
    return response.data;
  },

  toggleEntry: async (entryId: string, category: string): Promise<GlossaryEntry> => {
    const headers = await authHeaders();
    const response = await api.put<GlossaryEntry>(
      `/api/glossary/${entryId}/toggle?category=${category}`,
      undefined,
      { headers }
    );
    return response.data;
  },
};
